const _ = require('lodash');

const impressionStatus = {
  PRECACHED: 'pre-cached',
  SERVED: 'served',
  COMPLETED: 'completed',
  CLICK: 'click',
  LEAD: 'lead',
};
module.exports.impressionStatus = impressionStatus;
module.exports.impressionStatusValues = _.values(impressionStatus);

const apiRequestMode = {
  PENDING: 'pending',
  REJECTED: 'rejected',
  APPROVED: 'approved',
};
module.exports.apiRequestMode = apiRequestMode;
module.exports.apiRequestModeValues = _.values(apiRequestMode);

const apiRequestType = {
  PUBLIC: 'public',
  SERVER: 'server',
};
module.exports.apiRequestType = apiRequestType;
module.exports.apiRequestTypeValues = _.values(apiRequestType);

const clickStatus = {
  COMPLETED: 'completed',
  REJECTED: 'rejected',
};
module.exports.clickStatus = clickStatus;
module.exports.clickStatusValues = _.values(clickStatus);

const appStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  TEST: 'test',
};
module.exports.appStatus = appStatus;
module.exports.appStatusValues = _.values(appStatus);

const adUnitType = {
  REWARDED_VIDEO: 'rewarded_video',
  OFFER_WALL: 'offer_wall',
  SURVEYTIME: 'surveytime',
  VIDEO_INTERSTITIAL: 'video_interstitial',
  REWARDED_POPUP: 'rewarded_popup',
  NATIVE_AD: 'native_ad',
  APP_WALL: 'app_wall',
};
module.exports.adUnitType = adUnitType;
module.exports.adUnitTypeValues = _.values(adUnitType);

const adUnitName = {
  REWARDED_VIDEO: 'Rewarded Moments',
  OFFER_WALL: 'Offer Wall',
  SURVEYTIME: 'Surveytime',
  VIDEO_INTERSTITIAL: 'Interstitial',
  REWARDED_POPUP: 'Rewarded Pop-up',
  NATIVE_AD: 'Native Ads',
  APP_WALL: 'App Wall',
};
module.exports.adUnitName = adUnitName;
module.exports.adUnitNameValues = _.values(adUnitName);

module.exports.surveyTimeApp = {
  platform: 'web',
  name: 'Surveytime offer',
  type: 'rewards',
  iconUrl: null,
  originIconUrl: null,
  url: 'https://surveytime.io',
  os: 'Web',
  status: appStatus.INACTIVE,
  creativesUrls: [
    'https://assets.persona.ly/static/surveytime_1XDTQFNIxwZ7RqQ_728X90.png',
    'https://assets.persona.ly/static/surveytime_QpJRqfDGKedwlm9_480X320.png',
    'https://assets.persona.ly/static/surveytime_Ukd8O9epb8CpAq3_160X600.png',
    'https://assets.persona.ly/static/surveytime_Whqhc6saxtKOERP_250X250.png',
    'https://assets.persona.ly/static/surveytime_YdqPi3gbzcRgmo6_320X480.png',
    'https://assets.persona.ly/static/surveytime_xHyP0EKVXMc4OBW_300X250.png',
    'https://assets.persona.ly/static/surveytime_upNbAZTqwmG4hvO_320X50.png',
  ]
};

const adUnitColor = {
  REWARDED_VIDEO: '#3f51b5',
  OFFER_WALL: '#e91e63',
  VIDEO_INTERSTITIAL: '#673ab7',
  REWARDED_POPUP: '#00bcd4',
  NATIVE_AD: '#08c68e',
  APP_WALL: '#db4437',
};
module.exports.adUnitColor = adUnitColor;

const adUnitStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  TEST: 'test',
};
module.exports.adUnitStatus = adUnitStatus;
module.exports.adUnitStatusValues = _.values(adUnitStatus);

const role = {
  ADMIN: 'admin',
  PUBLISHER: 'publisher',
};
module.exports.role = role;
module.exports.roleValues = _.values(role);

const postbackType = {
  SERVER: 'pending',
  CLIENT: 'processing',
};
module.exports.postbackType = postbackType;
module.exports.postbackTypeValues = _.values(postbackType);

const postbackStatus = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  SUCCESS: 'success',
  FAIL: 'fail',
};
module.exports.postbackStatus = postbackStatus;
module.exports.postbackStatusValues = _.values(postbackStatus);

const cappingPeriod = {
  HOUR: 'hour',
  DAY: 'day',
};
module.exports.cappingPeriod = cappingPeriod;
module.exports.cappingPeriodValues = _.values(cappingPeriod);

const pacingPeriod = {
  MINUTE: 'minute',
  HOUR: 'hour',
};
module.exports.pacingPeriod = pacingPeriod;
module.exports.pacingPeriodValues = _.values(pacingPeriod);

const paymentMethodType = {
  WIRE_TRANSFER: 'wire_transfer',
  PAYPAL: 'paypal',
  LOCAL_BANK_TRANSFER: 'local_bank_transfer',
  PAYONEER_PREPAID_CARD: 'payoneer_prepaid_card',
};

module.exports.paymentMethodType = paymentMethodType;
module.exports.paymentMethodTypeValues = _.values(paymentMethodType);

const paymentMethodName = {
  WIRE_TRANSFER: 'Wire Transfer',
  PAYPAL: 'PayPal',
  LOCAL_BANK_TRANSFER: 'Local Bank Transfer',
  PAYONEER_PREPAID_CARD: 'Payoneer Prepaid Card',
};

module.exports.paymentMethodName = paymentMethodName;
module.exports.paymentMethodNameValues = _.values(paymentMethodName);

const paymentMethodTypeName = {
  [paymentMethodType.WIRE_TRANSFER]: paymentMethodName.WIRE_TRANSFER,
  [paymentMethodType.PAYPAL]: paymentMethodName.PAYPAL,
  [paymentMethodType.LOCAL_BANK_TRANSFER]: paymentMethodName.LOCAL_BANK_TRANSFER,
  [paymentMethodType.PAYONEER_PREPAID_CARD]: paymentMethodName.PAYONEER_PREPAID_CARD,
};

module.exports.paymentMethodTypeName = paymentMethodTypeName;

const NOT_DEFINED = Symbol('NOT_DEFINED');
module.exports.NOT_DEFINED = NOT_DEFINED;

const ECPM_RATIO = 1000;
module.exports.ECPM_RATIO = ECPM_RATIO;

const DEFAULT_REV_SHARE = 0.7;
module.exports.DEFAULT_REV_SHARE = DEFAULT_REV_SHARE;

module.exports.emailsWhiteList = [
  'victor@persona.ly',
];

module.exports.requestUrlTypeValues = [
  'init',
  'getCampaigns',
  'nativeAd',
  'sdkNativeAd',
  'canView',
  'canReward',
  'reportImpression',
  'reportClick',
  'reportNativeClick',
  'trackInstall',
  'reportCampaignStarted',
  'reportCampaignFinished',
  'logError',
  'getAppWall',
  'addImpression',
  'getOffers',
];

module.exports.videoAdUnits = ['rewarded_video', 'video_interstitial'];

const campaignTypes = {
  PLAYABLE: 'playable',
  VIDEO: 'video',
};

module.exports.campaignTypes = campaignTypes;

const apiRequestModes = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
};

module.exports.apiRequestModes = apiRequestModes;

module.exports.androidVersions = [
  '8.0',
  '7.0',
  '6.0',
  '5.1',
  '5.0',
  '4.4',
  '4.3',
  '4.1',
  '4.0',
  '3.0',
  '2.0',
  '1.0',
];

module.exports.iosVersions = [
  '11.0',
  '10.3',
  '10.2',
  '10.1',
  '10.0',
  '9.3',
  '9.2',
  '9.1',
  '9.0',
  '8.4',
  '8.3',
  '8.2',
  '8.1',
  '8.0',
  '7.1',
  '7.0',
  '6.1',
  '6.0',
];

module.exports.AVAILABLE_PLATFORMS = {
  ANDROID: 'Android',
  IPAD: 'iPad',
  IPHONE: 'iPhone',
};

const gender = {
  MALE: 'male',
  FEMALE: 'female',
};
module.exports.gender = gender;

module.exports.IMAGE_PROCESSING_TYPES = {
  COMPRESSION_FAILED: 'compression_failed',
};



/** WEBPACK FOOTER **
 ** ../server/enums.js
 **/